function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import GenericFormElement from '../GenericFormElement';
import withMapping from '../../../Context/withMapping';
import { useExtendedFormikContext } from '../FormikWrapper';
import './style.scss';
export var Checkbox = function Checkbox(props) {
  var title = props.title,
    required = props.required,
    description = props.description,
    fieldName = props.fieldName,
    validation = props.validation,
    _onChange = props.onChange,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    disabled = props.disabled;
  var _useExtendedFormikCon = useExtendedFormikContext(),
    values = _useExtendedFormikCon.values,
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isTouched = touched[fieldName];
  var value = values[fieldName];
  var error = errors[fieldName];
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && !value) {
      return t(['webform.components.checkbox.required', 'webform.required', 'webform_required']);
    }
  };
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('Checkbox', wrapperClassName),
    required: required,
    description: description,
    fieldName: fieldName,
    touched: isTouched,
    error: error,
    errorId: errorId,
    descriptionId: descriptionId,
    displayRequiredIndicator: displayRequiredIndicator
  }, /*#__PURE__*/React.createElement(Field, {
    required: required,
    name: fieldName,
    value: value,
    validate: handleValidation
  }, function (_ref) {
    var field = _ref.field,
      form = _ref.form;
    var id = "".concat(props.fieldName, "--").concat(props.value);
    var classes = c('WebformCheckboxes__checkbox__input', {
      'icon-before': true,
      'icon-checkmark': true,
      'icon-variant-0': !field.value,
      'icon-variant-1': field.value
    });
    return /*#__PURE__*/React.createElement("label", {
      className: classes,
      htmlFor: id
    }, /*#__PURE__*/React.createElement("input", _extends({}, field, {
      name: fieldName,
      type: "checkbox",
      id: id,
      checked: field.value,
      onChange: function onChange(e) {
        field.onChange(e);
        _onChange(!field.value);
      },
      disabled: disabled,
      className: className,
      required: required,
      "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
      "aria-invalid": Boolean(error)
    })), typeof title === 'string' ? ReactHtmlParser(title) : title);
  }));
};
Checkbox.defaultProps = {
  required: false,
  description: undefined,
  validation: undefined,
  onChange: function onChange() {},
  className: undefined,
  wrapperClassName: undefined,
  disabled: false
};
Checkbox.propTypes = {
  title: PropTypes.node.isRequired,
  required: PropTypes.bool,
  description: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  validation: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  disabled: PropTypes.bool
};
export default withMapping(Checkbox);